/* NA LEIBERL – Maskottchen: die grantige Taube fliegt in zufaelligen Abstaenden
   ueber die Seite (abwechselnd von rechts nach links und von links nach rechts) und laesst dabei einen Klecks fallen.
   - laeuft auf allen Seiten, stoert keine Klicks (pointer-events: none)
   - pausiert, solange der Tab im Hintergrund ist
   - keine Animation bei "Bewegung reduzieren" (Betriebssystem-Einstellung)
   Einstellungen unten bei CONFIG. Bilder kommen aus snippets/meta-tags.liquid (window.NL_TAUBE). */
(function () {
  var CONFIG = {
    ersterFlugMin: 6,      // Sekunden bis zum ersten Flug (zufaellig zwischen min und max)
    ersterFlugMax: 15,
    abstandMin: 20,        // Sekunden zwischen zwei Fluegen (zufaellig)
    abstandMax: 50, 
    flugDesktop: [7.5, 8.5], // Sekunden fuer einmal quer ueber den Bildschirm am Desktop (zufaellig dazwischen)
    flugHandy: [6.5, 7.5],   // ... und am Handy
    flatterMs: 170,        // Wechsel Fluegel oben/unten
    klecksBleibt: 3500     // ms, bis der Klecks wieder verschwindet
  };

  var cfg = window.NL_TAUBE;
  if (!cfg || !cfg.frames || cfg.frames.length < 2) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var KLECKS = '<svg viewBox="0 0 120 80" aria-hidden="true" focusable="false">' +
    '<path d="M60 14c9 0 12 9 20 10 9 1 17-3 22 4 5 8-4 13-2 20 2 8 12 9 10 17-2 7-13 6-20 5-8-1-12 6-21 6-9 0-12-6-20-6-9 0-18 5-24-1-6-6 1-13-1-20-2-7-12-10-9-18 3-8 13-5 20-6 8-1 13-11 25-11z" fill="#fff" stroke="#211D1E" stroke-width="5" stroke-linejoin="round"/>' +
    '<circle cx="12" cy="18" r="5" fill="#fff" stroke="#211D1E" stroke-width="4"/>' +
    '<circle cx="108" cy="12" r="4" fill="#fff" stroke="#211D1E" stroke-width="4"/>' +
    '<circle cx="104" cy="70" r="3.5" fill="#fff" stroke="#211D1E" stroke-width="3.5"/>' +
    '<path d="M44 40c4-5 12-6 16-1" fill="none" stroke="#211D1E" stroke-width="3" stroke-linecap="round" opacity=".35"/></svg>';
  var TROPFEN = '<svg viewBox="0 0 30 40" aria-hidden="true" focusable="false">' +
    '<path d="M15 3c5 9 11 15 11 23a11 11 0 0 1-22 0C4 18 10 12 15 3z" fill="#fff" stroke="#211D1E" stroke-width="4" stroke-linejoin="round"/></svg>';

  var css = '' +
    '.nl-taube{position:fixed;left:0;top:0;z-index:60;pointer-events:none;will-change:transform}' +
    '.nl-taube__in{position:absolute;inset:0}.nl-taube.is-rechts .nl-taube__in{transform:scaleX(-1)}' +
    '.nl-taube img{position:absolute;left:0;top:0;width:100%;height:auto;display:block}' +
    '.nl-taube img+img{visibility:hidden}' +
    '.nl-taube.is-down img:first-child{visibility:hidden}.nl-taube.is-down img+img{visibility:visible}' +
    '.nl-tropfen{position:fixed;left:0;top:0;z-index:59;width:14px;height:19px;pointer-events:none;will-change:transform}' +
    '.nl-tropfen svg,.nl-klecks svg{width:100%;height:100%;display:block}' +
    '.nl-klecks{position:absolute;z-index:59;width:54px;height:36px;margin:-18px 0 0 -27px;pointer-events:none;' +
      'animation:nlKlecksIn .25s cubic-bezier(.2,1.6,.4,1) both}' +
    '.nl-klecks.is-weg{transition:opacity .6s ease;opacity:0}' +
    '@keyframes nlKlecksIn{0%{transform:scale(.2,.2)}60%{transform:scale(1.25,.75)}100%{transform:scale(1,1)}}' +
    '@media (max-width:749px){.nl-klecks{width:42px;height:28px;margin:-14px 0 0 -21px}}';

  function rnd(a, b) { return a + Math.random() * (b - a); }
  function el(tag, cls, html) { var e = document.createElement(tag); e.className = cls; if (html) e.innerHTML = html; return e; }

  var timer = null, fliegt = false, geladen = false;
  var nachRechts = Math.random() < 0.5;            // Startrichtung zufaellig, danach immer abwechselnd

  function bilderLaden(cb) {
    if (geladen) return cb();
    var n = 0;
    cfg.frames.slice(0, 2).forEach(function (src) {
      var i = new Image();
      i.onload = i.onerror = function () { if (++n === 2) { geladen = true; cb(); } };
      i.src = src;
    });
  }

  function planen(min, max) {
    clearTimeout(timer);
    timer = setTimeout(start, rnd(min, max) * 1000);
  }

  function start() {
    if (document.hidden || fliegt) { planen(CONFIG.abstandMin, CONFIG.abstandMax); return; }
    bilderLaden(flug);
  }

  function flug() {
    fliegt = true;
    var vw = window.innerWidth, vh = window.innerHeight;
    var breite = vw < 750 ? 82 : 118;              // Groesse der Taube in px
    var hoehe = breite * 0.75;
    var dir = nachRechts ? 1 : -1;                  // 1 = fliegt nach rechts, -1 = nach links
    nachRechts = !nachRechts;
    var wrap = el('div', 'nl-taube' + (dir === 1 ? ' is-rechts' : ''));
    var innen = el('div', 'nl-taube__in');
    wrap.appendChild(innen);
    wrap.setAttribute('aria-hidden', 'true');
    wrap.style.width = breite + 'px';
    wrap.style.height = hoehe + 'px';
    cfg.frames.slice(0, 2).forEach(function (src, i) {
      var img = new Image();
      img.src = src; img.alt = ''; img.decoding = 'async';
      var off = (cfg.offsets && cfg.offsets[i]) || [0, 0];   // Ausrichtung der beiden Posen
      img.style.transform = 'translate(' + (off[0] * breite) + 'px,' + (off[1] * breite) + 'px)';
      innen.appendChild(img);
    });
    document.body.appendChild(wrap);

    var span = vw < 750 ? CONFIG.flugHandy : CONFIG.flugDesktop;
    var dauer = rnd(span[0], span[1]) * 1000;
    var yBasis = rnd(vh * 0.12, vh * 0.45);
    var welle = rnd(14, 30), wellen = rnd(1.2, 2.2);
    var links = -breite - 40, rechts = vw + 40;
    var xStart = dir === 1 ? links : rechts, xEnde = dir === 1 ? rechts : links;
    var abwurf = rnd(0.25, 0.7), abgeworfen = false;
    var t0 = null, letzterFlap = 0, unten = false;

    function frame(ts) {
      if (!t0) t0 = ts;
      var p = (ts - t0) / dauer;
      if (p >= 1) { wrap.remove(); fliegt = false; planen(CONFIG.abstandMin, CONFIG.abstandMax); return; }
      var x = xStart + (xEnde - xStart) * p;
      var y = yBasis + Math.sin(p * Math.PI * 2 * wellen) * welle;
      var neigung = Math.cos(p * Math.PI * 2 * wellen) * 4 * -dir;
      wrap.style.transform = 'translate(' + x + 'px,' + y + 'px) rotate(' + neigung + 'deg)';
      if (ts - letzterFlap > CONFIG.flatterMs) { unten = !unten; wrap.classList.toggle('is-down', unten); letzterFlap = ts; }
      if (!abgeworfen && p >= abwurf && x > 30 && x < vw - 60) {
        abgeworfen = true;
        fallenLassen(x + breite * (dir === 1 ? 0.38 : 0.62), y + hoehe * 0.62, dir);   // unter dem Schwanz
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function fallenLassen(x, y, dir) {
    var vh = window.innerHeight;
    var tropfen = el('div', 'nl-tropfen', TROPFEN);
    document.body.appendChild(tropfen);
    var ziel = Math.min(vh - 40, y + rnd(180, vh * 0.55));
    var drift = rnd(10, 30) * dir;                  // fliegt noch etwas in Flugrichtung mit
    var t0 = null, g = 2600;                        // px/s^2
    var fallzeit = Math.sqrt(2 * (ziel - y) / g) * 1000;
    function fall(ts) {
      if (!t0) t0 = ts;
      var t = Math.min((ts - t0) / fallzeit, 1);
      var s = (ts - t0) / 1000;
      var cy = y + 0.5 * g * s * s;
      var cx = x + drift * t;
      if (t >= 1) { tropfen.remove(); landen(cx, ziel); return; }
      tropfen.style.transform = 'translate(' + (cx - 7) + 'px,' + (cy - 10) + 'px)';
      requestAnimationFrame(fall);
    }
    requestAnimationFrame(fall);
  }

  function landen(x, y) {
    // Klecks klebt an der Seite (scrollt mit) statt am Bildschirm
    var k = el('div', 'nl-klecks', KLECKS);
    k.setAttribute('aria-hidden', 'true');
    k.style.left = (x + window.scrollX) + 'px';
    k.style.top = (y + window.scrollY) + 'px';
    k.firstChild.style.transform = 'rotate(' + rnd(-20, 20) + 'deg)';
    document.body.appendChild(k);
    setTimeout(function () {
      k.classList.add('is-weg');
      setTimeout(function () { k.remove(); }, 700);
    }, CONFIG.klecksBleibt);
  }

  function init() {
    var s = document.createElement('style');
    s.textContent = css;
    document.head.appendChild(s);
    planen(CONFIG.ersterFlugMin, CONFIG.ersterFlugMax);
    // Tab wieder sichtbar: nicht sofort losfliegen, sondern neu planen
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && !fliegt) planen(8, 25);
    });
    // Zum Testen in der Konsole: nlTaube()
    window.nlTaube = function () { if (fliegt) return; clearTimeout(timer); bilderLaden(flug); };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
